import { render } from "./AssetWidget.vue?vue&type=template&id=0dabc542&scoped=true"
import script from "./AssetWidget.vue?vue&type=script&lang=js"
export * from "./AssetWidget.vue?vue&type=script&lang=js"

import "./AssetWidget.vue?vue&type=style&index=0&id=0dabc542&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dabc542"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBadge,QBtn,QTooltip});
